import { ContentType } from 'utils/getContentType';
import { PreviewGridInner } from './PreviewGridWrapper';
import PageLoader from 'components/page-loader/page-loader';
import { trackError } from '@proposify/frontend-observability';
import { URLS } from 'utils/urls';
import { navigate } from 'utils/navigate';
import type { GetDocumentResponse } from 'services/documents/DocumentRepository';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { contentQueries } from 'services/content/contentQueries';

export function PreviewByContentId({ contentId }: { contentId: string }) {
  const { data: documentData, status } = useQuery(contentQueries.publicContentMetadataById(ContentType.DOCUMENT, contentId));

  useEffect(() => {
    if (status === 'error') {
      navigate(URLS.errorForbiddenAccess);
    }
  }, [status]);

  if (status === 'error') {
    trackError(new Error(`PreviewByContentId: failed to fetch metadata for contentId: ${contentId}`), {
      errorFrom: 'editor-remote',
      feature: 'preview',
    });
    return <PageLoader isLoading isLoaded={false} />;
  }

  if (status === 'pending' || !documentData) {
    return <PageLoader isLoading isLoaded={false} />;
  }

  // ContentMetadata is Partial<GetDocumentById> — for a DOCUMENT type the fields are always
  // present at runtime, so the cast is safe here.
  return <PreviewGridInner contentId={contentId} documentData={documentData as GetDocumentResponse} />;
}
